import React from "react";
import nodata from "../../assets/images/no-data.png";

function MedicalReportDataListing({ responseData }) {
  // Determine where the actual data lives
  const result =
    responseData?.result || // old structure
    responseData?.pages?.[0]?.extractedData || // new structure
    {};
  // Recursive rendering of nested objects/arrays
  const renderData = (data) => {
    return Object.entries(data)?.map(([key, value]) => {
      if (value === null || value === undefined) return null;

      // Handle nested objects
      if (typeof value === "object" && !Array.isArray(value)) {
        return (
          <div key={key} className="col-12 mb-3">
            <h5 className="font_15 fw-bold text_master2 mb-2 text-capitalize">
              {key.replace(/_/g, " ")}
            </h5>
            <div className="row ps-3">{renderData(value)}</div>
          </div>
        );
      }

      // Handle arrays (like Checklist categories)
      if (Array.isArray(value)) {
        return (
          <div key={key} className="col-12 mb-3">
            <h5 className="font_15 fw-bold text_master2 mb-2 text-capitalize">
              {key.replace(/_/g, " ")}
            </h5>
            <ul className="ps-3 mb-0">
              {value.map((item, index) => (
                <li
                  key={index}
                  className="text_master2 fw_600 word_break text-start"
                >
                  {item || "-"}
                </li>
              ))}
            </ul>
          </div>
        );
      }

      // Handle simple key-value pairs
      return (
        <div key={key} className="col-12 py-2 document_values pb-0 pb-sm-2">
          <div className="row">
            <div className="col-12 font_500 col-md-6 text_gray8 text-capitalize">
              {key.replace(/_/g, " ")}
            </div>
            <div className="col-12 col-md-6 pt-1 pt-sm-0 mb-3 mb-sm-0">
              <div className="d-flex justify-content-start">
                <span className="text_master2 fw_600 word_break text-start">
                  {String(value) || "-"}
                </span>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  const hasData = result && Object.keys(result).length > 0;

  return (
    <div className="extracted_data_section pb-3 overflow-auto scrollbar1 px-0 px-md-3 px-md-0 position-relative">
      <div className="pt-3 pt-md-0">
        <h2 className="font_16 fw-bold mb-3 text-center pt-2 mb-2">
          Extracted Data
        </h2>
      </div>

      {hasData ? (
        <div className="px-3 pt-3 pb-1 font_13">
          <div className="row">{renderData(result)}</div>
        </div>
      ) : (
        <div className="d-flex flex-column align-items-center mt-0 mt-md-5">
          <img
            src={nodata}
            className="no_data_thumbnail object_fit_contain"
            alt="No Data"
          />
          <h4 className="text_gray7 font_16 mt-3">Unable To Process Data</h4>
        </div>
      )}
    </div>
  );
}

export default MedicalReportDataListing;
